<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col>
                <b-card>
                    <div slot="header">
                        <strong>{{poData.title}}</strong>
                    </div>
                    <b-row>
                        <b-col>
                            <b-row>
                                <b-col sm="12">
                                    <b-form-group>
                                        <label for="name">PO Date</label>
                                        <b-form-input type="date" id="name" placeholder="PO Date" v-model="poData.po_date" :disabled="lockEntry"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="3">
                                    <b-form-group >
                                        <label>Supplier</label>
                                        <supplierLookup v-bind:url="apiSupplierUrl" v-on:selected="setSupplier($event)" :lookupId="poData.supplier_id" :disabled="lockEntry"/>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="3">
                                    <b-form-group>
                                        <label>Receiving Warehouse</label>
                                        <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="poData.location_id" :disabled="lockEntry"/>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="2">
                                    <b-form-group>
                                        <label>Type</label>
                                        <b-form-select v-model="poData.po_type"
                                            :plain="true"
                                            :options="['','TRADE','NON TRADE']"
                                            disabled
                                            >
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="2">
                                    <b-form-group >
                                        <label for="po_category">Category</label>
                                        <b-form-select id="po_category"  v-model="poData.po_category"
                                            :plain="true"
                                            :options="['-','LOCAL','OVERSEAS']"
                                            disabled
                                            >
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="2">
                                    <b-form-group>
                                        <label for="estDate">ETA</label>
                                        <b-form-input type="date" id="eta" placeholder="Est Delivery Date" v-model="poData.po_date_eta" :disabled="lockEntry"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <label for="remarks">Remarks</label>
                                    <textarea class="form-control" rows="5" id="remarks" v-model="poData.remarks" :disabled="lockEntry"></textarea>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col sm="4" v-if="poData.grns.length > 0">
                            <br/>
                            <b-card>
                                <div class="table-responsive">
                                    <table>
                                        <thead>
                                            <th style="min-width:138px;height:40px">GRN No</th>
                                            <th style="min-width:100px">Date</th>
                                            <th>Generated By</th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="row, index in poData.grns" :ref="'title'" style="height:40px">
                                                <td>
                                                    <b-button type="submit" size="md" variant="primary" @click="printGRN(row)">{{row.grn_num}}</b-button>  
                                                </td>
                                                <td>{{row.grn_date_friendly}}</td>
                                                <td>{{row.author_user_shortname}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </b-card>                                
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="poData.supplier_id !='' && poData.location_id != '' && !noItemsFound">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>Purchase Order Items</strong>
                    </div>
                    <div class="table-responsive">
                        <table class='table table-striped table-bordered'>
                            <thead>
                                <th style="width:10px">S/N</th>
                                <th style="min-width:300px">Product</th>
                                <th width="150px">SKU</th>
                                <th>UOM</th>
                                <th width="150px">Quantity</th>
                                <th width="180px">Unit Price ({{poData.currency_id}})</th>
                                <th width="180px">Amount ({{poData.currency_id}})</th>
                                <th width="30px"></th>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in poData.po_items" :ref="'title'" v-if="!lockEntry">
                                    <td>{{(index*1) +1}}</td>
                                    <td>
                                        <productLookup v-bind:url="apiProductUrl" v-on:selected="setProduct($event, index)" :q2="poData.location_id" :lookupId="row.product_id" :disabled="lockEntry"/>
                                    </td>
                                    <td>{{row.product_id}}</td>
                                    <td>{{row.uom}}</td>
                                    <td><input type="number" name="qty" v-model="row.qty" class="form-control" @change="computeRow($event, index)" ></td>
                                    <td><input type="number" name="unit_price" v-model="row.unit_price" class="form-control" @change="computeRow($event, index)"></td>
                                    <td><input type="number" name="amount_total" v-model="row.amount_total"  class="form-control" @change="computeRow($event, index)" ></td>
                                    <td><a href="#" @click="removeRow(index)" v-if="!lockEntry"><i class='fa fa-trash' style="font-size:25px;color:red;"></i></a></td>
                                </tr>
                                <tr v-for="row, index in poData.po_items" :ref="'title'" v-if="lockEntry">
                                    <td>{{(index*1) +1}}</td>
                                    <td>
                                        <productLookup v-bind:url="apiProductUrl" v-on:selected="setProduct($event, index)" :q2="poData.location_id" :lookupId="row.product_id" :disabled="lockEntry"/>
                                    </td>
                                    <td>{{row.product_id}}</td>
                                    <td>{{row.uom}}</td>
                                    <td><input type="text" name="qty" v-model="row.qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" class="form-control"disabled></td>
                                    <td><input type="text" name="unit_price" v-model="row.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')" class="form-control" disabled></td>
                                    <td><input type="text" name="amount_total" v-model="row.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')"  class="form-control"  disabled></td>
                                    <td></td>
                                </tr>
                                <tr v-if="!lockEntry">
                                    <td colspan=8>
                                        <b-button type="submit" size="md" variant="success" @click="addRow">Add Product</b-button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Amount ($)</b></td>
                                    <td>{{total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td><b>Tax (%)</b></td>
                                  <td>{{poData.tax_percent}}</td>
                                  <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Tax Amount ($)</b></td>
                                    <td v-if="!lockEntry">{{gstAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    <td v-if="lockEntry">{{poData.amount_tax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Rounding Amount ($)</b></td>
                                    <td><input type="number" name="amount_total_rounding" class="form-control" v-model="poData.amount_total_rounding" :disabled="lockEntry"></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total Amount ($)</b></td>
                                    <td v-if="!lockEntry"><b>{{totalAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</b></td>
                                    <td v-if="lockEntry"><b>{{poData.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</b></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="poData.supplier_id !='' && poData.location_id != '' && !noItemsFound">
            <b-col sm="12">
                <b-row style="padding: 0px 0px 20px 18px;">
                        <b-button type="submit" size="lg" variant="primary" @click="confirmProcessPO" v-if="po_status == 'PENDING' && hideBtn">{{confirmBtnText}}</b-button>
                        &nbsp;&nbsp;
                        <b-modal v-model="modalShow" @ok="processPO" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                            <p style="color:darkblue">Confirmed {{confirmMessage}}?</p>
                        </b-modal>
                        <b-modal v-model="cancelModalShow" @ok="cancel" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                            <p style="color:darkblue">Confirmed {{confirmMessage}}?</p>
                        </b-modal>
                            <b-modal ref="myModalRef" hide-header-close hide-footer title="Purchase Order" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                                <div class="d-block text-center">
                                    <p>Purchase Order <strong style="color:green"> {{poDocumentNo}}</strong> is {{msgSaved}}.<br/><br/></p>
                                </div>
                                    <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
                            </b-modal>
                            <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop>
                                <div class="d-block text-center">
                                    <p style="color:red">{{errorMessage}}</p>
                                </div>
                                    <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
                            </b-modal>
                            <b-modal ref="myApproveModalRef" hide-header-close hide-footer title="Approved" centered header-bg-variant="primary" no-close-on-backdrop no-close-on-esc>
                                <div class="d-block text-center">
                                    <p style="color:green">Purchase Order {{this.$route.params.poNum}} has been approved</p>
                                </div>
                                    <b-btn class="float-right" variant="danger" @click="hideApproveModal">OK</b-btn>
                            </b-modal>
                            <b-modal ref="msgBox" hide-header-close hide-footer :title="mbTitle" centered header-bg-variant="primary" no-close-on-backdrop no-close-on-esc>
                                <div class="d-block text-center">
                                    <p style="color:green">{{mbMsg}}</p>
                                </div>
                                    <b-btn class="float-right" variant="danger" @click="$refs.msgBox.hide()">OK</b-btn>
                            </b-modal>
                            <b-modal ref="myCancelModalRef" hide-header-close hide-footer title="Cancelled" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                                <div class="d-block text-center">
                                    <p style="color:red">Purchase Order {{this.$route.params.poNum}} has been cancelled</p>
                                </div>
                                    <b-btn class="float-right" variant="danger" @click="hideCancelModal">OK</b-btn>
                            </b-modal>
                            <b-modal id="modalPrevent"
                                ref="manualCloseModal"
                                title="Manual Close PO?"
                                centered
                                @ok="manualClosePO"
                                >
                                <form @submit.stop.prevent="handleSubmit">
                                    <b-form-input type="text" placeholder="Enter the reason" v-model="poData.po_fulfilment_remarks"></b-form-input>
                                </form>
                            </b-modal>
                        <b-button type="submit" size="lg" variant="danger" @click="confirmCancel" v-if="po_status == 'PENDING'">{{cancelBtnText}}</b-button>
                        <b-button type="button" size="lg" variant="primary" @click="confirmManualClose"  v-if="po_status == 'APPROVED' && (po_fulfilment_status =='UNFULFILLED' || po_fulfilment_status =='PARTIAL')" >Manual Close</b-button>
                        &nbsp;&nbsp;
                        <b-button type="button" size="lg" variant="success" @click="print" v-if="poData.po_num != '' && poData.po_status != 'CANCELLED'">Print</b-button>
                        &nbsp;&nbsp;
                        <b-button type="button" size="lg" variant="danger" @click="back"  v-if="po_status != 'PENDING'" >Back</b-button>
                </b-row>
            </b-col>
        </b-row>
        <b-row  v-if="poData.location_id != '' && poData.supplier_id !='' && noItemsFound">
                <b-col sm="12">
                    <div align="center">
                        <strong style="color:red">There is no product listed under the selected Warehouse's Country of Origin.</strong>
                    </div>                    
                </b-col>
        </b-row>
</div>
 </template>
 <script>
    import axios from 'axios'
    import {authHeader, apiSupplierLookup, apiWarehouseLookup, apiProductLookup, apiPOSave, apiPoGet, apiPOApprove,apiCountryLookup} from '@/functions/common.vue'
    import supplierLookup from '@/components/Autocomplete.vue'
    import warehouseLookup from '@/components/Autocomplete.vue'
    import testLookup from '@/components/Autocomplete.vue'
    import productLookup from '@/components/Autocomplete.vue'
    import {apiProduct} from '@/functions/common.vue'
    import {apiPOManualClose} from '@/functions/common.vue'
    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    pdfMake.fonts = {
        "ukai": {
            normal: 'ukai.ttf',
            bold: 'ukai.ttf',
            italics: 'ukai.ttf',
            bolditalics: 'ukai.ttf'
        },
        "Garuda": {
            normal: 'Garuda.ttf',
            bold: 'Garuda.ttf',
            italics: 'Garuda.ttf',
            bolditalics: 'Garuda.ttf'
        },
        "Hanumanb": {
            normal: 'Hanumanb.ttf',
            bold: 'Hanumanb.ttf',
            italics: 'Hanumanb.ttf',
            bolditalics: 'Hanumanb.ttf'
        },
    };
    export default {
      name: 'poDetails',
      components:{supplierLookup,warehouseLookup,productLookup,testLookup},
      data: () => {
        return {
            mbTitle: "",
            mbMsg: "",
            savedTitle: '',
            po_status:'',
            country_name:'',
            msgSaved: '',
            closeBtn: false,
            hideBtn: true,
            font:'ukai',
            confirmBtnText: '',
            cancelBtnText:'',
            confirmMessage:'test',
            lockEntry: false,
            poRef: '',
            parentData: '',
            supplierId: '',
            prevSupplierId: '',
            apiSupplierUrl: apiSupplierLookup,
            apiWarehouseUrl: apiWarehouseLookup,
            apiProductUrl: apiProductLookup,
            apiPOManualClose:apiPOManualClose,
            warehouseDisplay: '',
            modalShow:false,
            cancelModalShow:false,
            prevWhID:'',
            productId:'',
            countryId: '',
            poItemsCount: 1,
            currency_id:'',
            errorMessage: 'Error',
            isSuccess: true,
            poDocumentNo:'',
            noItemsFound:true,
            visible:true,
            isValid : true,
            selected : false,
            po_fulfilment_status:'',
            poData: {
                po_num: '',
                po_date: '', supplier_id: '', location_id: '', po_type: '-', po_category: '-', po_date_eta: '', remarks: '', currency_id: '', 
                po_fulfilment_remarks:'',
                grns: [],
                po_items: [
                    {product_name:'', product_id:'', uom:'', qty:'',unit_price:'', amount_total:''}
                ], title: '',
                tax_amount:0,
                tax_percent:0,
                total_amount:0,
                amount_total_rounding: 0
          }
        }
      },
      created: function()
      {
       
        this.poRef = this.$route.params.poNum
        if (this.poRef == '_new')
        {
            this.poRef = '';
            this.po_status ='PENDING';
        }
        this.poData.po_num = this.poRef

        if (this.poData.po_num == '')
        {
            this.poData.title = 'New Purchase Order'
            this.msgSaved = "created"
            this.confirmBtnText = 'Save Purchase Order'
            this.cancelBtnText = 'Cancel'
            this.lockEntry = false
            this.noItemsFound = true
        }
        else
        {
            this.poData.title = 'Purchase Order ' + this.poData.po_num
            this.msgSaved = "saved"
            this.confirmBtnText = 'Confirm PO'
            this.cancelBtnText = ' Reject PO'
            this.lockEntry = true
            this.noItemsFound = false
        }
        if (this.poRef == '' && this.poData.po_date == '')
        {
            let curDate = new Date()
            curDate = curDate.toISOString().substr(0,10)
            this.poData.po_date = curDate
        }
        else
        {
            this.fetchPO(this.poRef)
        }
      },
      computed: 
      {
        gstAmount() 
        {
          return this.poData.po_items.reduce((gstAmount) => {
            return ((this.poData.tax_percent*1)/100)* (this.total*1);
          }, 0);
        },
        totalAmount() {
          return this.poData.po_items.reduce((totalAmount) => {
            return this.total + this.gstAmount + (this.poData.amount_total_rounding*1);
          }, 0);
        },
        total() {
          return this.poData.po_items.reduce((total, item) => {
            return total + (item.amount_total*1);
          }, 0);
        },
    },
      methods: 
      {
        printGRN(row) 
            {
                var grn_num = row.grn_num
                    var r = []
                    var grnsItems = []
                    var groTotalAmount = 0
                    r = 
                    [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                    ]
                    grnsItems.push(r)
         
                    var items = row.grn_items
                    for (let key in items) {
                        var data = items[key]
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null) 
                        {
                            data.product_name = ""
                        }
                        r = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                        ]
                        grnsItems.push(r)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN '+  this.country_name +' GOOD RECEIVED NOTE',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'GRN #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: grn_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]
                                        },
                                        {
                                            text:' '
                                        },
                                        {
                                            columns: [

                                                {
                                                    text: 'GRN Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: row.grn_date_friendly,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]

                                        },
                                        {
                                            text:' ',
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Reference PO #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: row.po_num,
                                                    style: 'invoiceSubValue',
                                                },

                                            ]

                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = 
                    {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: grn_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 68, '*', 45, 45],
                                    body: grnsItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: row.remarks,
                                style: 'notesText'
                            },
                        {
                          columns: [
                                {
                                    stack: [
                                        { 
                                            text: 'Received By',
                                            style:'signaturePlaceholder'
                                        },

                                        { 
                                            text: '______________________________',
                                            style:'signaturePlaceholder'
                                        },
                                        { 
                                            text: 'Name  :',
                                            style:'signatureName'
                                            
                                        },
                                        { 
                                            text: 'Date  :',
                                            style:'signatureJobTitle'
                                            
                                        }
                                        ],
                                width: 160
                                },                
                            ]
                        },  
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 20,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:this.font
                        }
                    }
                    pdfMake.createPdf(dd).open();
        },
        print()
        {
            var po_num = this.poData.po_num
            var row = []
            var date =new Date(this.poData.po_date)
            var poDate =  "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
            var deliveryDate =''
            var payment_terms = '-'

            if(this.poData.payment_terms != null)
            {
                payment_terms = this.poData.payment_terms
            }

            if(this.poData.po_date_eta != null)
            {
                deliveryDate = new Date(this.poData.po_date_eta)
                deliveryDate = "" + (deliveryDate.getDate() > 9 ? '' : '0') + deliveryDate.getDate() + '/'+  ((deliveryDate.getMonth() + 1) > 9 ? '' : '0') + (deliveryDate.getMonth() + 1) + '/' + deliveryDate.getFullYear()
            }
            else
            {
                deliveryDate = '-'
            }
            if(this.poData.po_status == "APPROVED" && this.poData.po_status_date != null)
            {
                var poStatusDate = new Date(this.poData.po_status_date)
                poStatusDate = "" + (poStatusDate.getDate() > 9 ? '' : '0') + poStatusDate.getDate() + '/'+  ((poStatusDate.getMonth() + 1) > 9 ? '' : '0') + (poStatusDate.getMonth() + 1) + '/' + poStatusDate.getFullYear()
            }
            else
            {
                poStatusDate ="-"
            }
            var poApprover
            if(this.poData.po_status == "APPROVED" && this.poData.approver_user_shortname != null )
            {
                poApprover = this.poData.approver_user_shortname
            }
            else
            {
                poApprover = "-"
            }
            var poItems = []
            var poTotalAmount = 0
            row = [
                {text: 'S/No', style: 'itemsHeader'}, 
                {text: 'Product Code', style: ['itemsHeader'],alignment: 'left'}, 
                {text: 'Description', style: ['itemsHeader'],alignment: 'left'}, 
                {text: 'Unit Price', style: ['itemsHeader'], alignment: 'right'}, 
                {text: 'Qty', style: ['itemsHeader'], alignment: 'right'}, 
                {text: 'Amount', style: ['itemsHeader'], alignment: 'right'} 
            ]
            poItems.push(row)
            var items = this.poData.po_items
            for (let key in items)
            {
                var data = items[key]
                poTotalAmount = poTotalAmount + (data.amount_total * 1)
                var unit_price = (data.unit_price * 1).toFixed(2)
                unit_price = data.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                var amount_total = (data.amount_total*1).toFixed(2)
                amount_total = data.amount_total
                var totalAmount = data.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                var qty = (data.qty *1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                if(data.product_name == null)
                {
                    data.product_name= ""
                }
                row = 
                [
                    {text: (key * 1) + 1, style:'itemText'}, 
                    {text: data.product_id,style:'itemText'}, 
                    {text: data.product_name, style:'itemText'}, 
                    {text: unit_price, style:'itemNumber'}, 
                    {text: qty, style:'itemNumber'},
                    {text: totalAmount, style:'itemTotal'}
                ]
                poItems.push(row)
            }
            poTotalAmount = poTotalAmount.toFixed(2)
            poTotalAmount = poTotalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
var ddHeader =
     {
         columns: [
             [
                 {
                     text: 'ELKEN ' + this.country_name+' PURCHASE ORDER', 
                     style: 'invoiceTitle',
                     width: '*'
                 },
                 {
                   stack: [
                        {
                            columns: [
                                 {
                                     text:'Supplier', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: this.poData.supplier_info,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 {
                                     text: '',style:'invoiceSubValue',width: 80
                                 },
                                 {
                                     text:'PO #', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: po_num,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 
                                 ]
                        },
                        {
                            columns: [
                                 {
                                     text:'Purchaser', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: this.poData.author_user_shortname,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 {
                                     text: '',style:'invoiceSubValue',width: 80
                                 },
                                 {
                                     text:'PO Date', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: poDate,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 
                                 ]
                        },
                        {
                            columns: [
                                 {
                                     text:'Stock Location', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: this.poData.location_info,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 {
                                     text: '',style:'invoiceSubValue',width: 80
                                 },
                                 {
                                     text:'Payment Terms', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: payment_terms,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 
                                 ]
                        },
                        {
                            columns: [
                                 {
                                     text:'Delivery Date', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: deliveryDate,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                                 {
                                     text: '',style:'invoiceSubValue',width: 80
                                 },
                                 {
                                     text:'Currency', 
                                     style:'invoiceSubTitle',
                                     width: 90
                                     
                                 }, 
                                 {
                                     text: this.poData.currency_id,
                                     style:'invoiceSubValue',
                                     width: 100
                                     
                                 },
                            ]
                        },
                    ]
                 }
             ],
         ],
     }

var dd = {
header: function(pageNumber, pageCount) {
        return {
            margin: [0,10,0,0],
            columns: [
                { text: '', style: 'documentHeaderLeft' },
                { text: po_num, style: 'documentHeaderCenter' },
                { text: '', style: 'documentHeaderRight' }
                ]
            }}, 
footer: function(pageNumber, pageCount) {
        return {
        margin: [0,0,0,50],
        columns: [
            { text: '', style: 'documentFooterLeft' },
            { text: 'Page ' + pageNumber + " of " + pageCount , style: 'documentFooterCenter' },
            { text: '', style: 'documentFooterRight' }
        ]
    };
},            
 content: [
     ddHeader,
     // Line breaks
     '\n\n',
     {
        layout: 'lightHorizontalLines',
        table: {

         headerRows: 1,
         widths: [25, 68, '*', 45, 38, 55],
         body: 
            poItems
         
       }, // table
     },
  // TOTAL
     {
       table: {
         // headers are automatically repeated if the table spans over multiple pages
         // you can declare how many rows should be treated as headers
         headerRows: 0,
         widths: [ '*', 80 ],
         body: 
         [
           // Total
           [ 
               {
                   text:'TOTAL ($)',
                   style:'itemsFooterTotalTitle',
                   alignment: 'right'

               }, 
               {
                   text: poTotalAmount,
                   style:'itemsFooterTotalValue',
                   alignment: 'right'
               }
           ],
         ]
       }, // table
       layout: 'lightHorizontalLines'
     },
     {
       table: {
         // headers are automatically repeated if the table spans over multiple pages
         // you can declare how many rows should be treated as headers
         headerRows: 0,
         widths: [ '*', 80 ],
         body: [
           // Tax
           [ 
               {
                   text:'Tax (%)',
                   style:'itemsFooterTotalTitle',
                   alignment: 'right'

               }, 
               {
                   text: this.poData.tax_percent,
                   style:'itemsFooterTotalValue',
                   alignment: 'right'
               }
           ],
         ]
       }, // table
       layout: 'lightHorizontalLines'
     },
     {
       table: {
         // headers are automatically repeated if the table spans over multiple pages
         // you can declare how many rows should be treated as headers
         headerRows: 0,
         widths: [ '*', 80 ],
         body: [
           // Tax
           [ 
               {
                   text:'Tax Amount ($)',
                   style:'itemsFooterTotalTitle',
                   alignment: 'right'

               }, 
               {
                   text: this.poData.amount_tax,
                   style:'itemsFooterTotalValue',
                   alignment: 'right'
               }
           ],
         ]
       }, // table
       layout: 'lightHorizontalLines'
     },
     {
       table: {
         // headers are automatically repeated if the table spans over multiple pages
         // you can declare how many rows should be treated as headers
         headerRows: 0,
         widths: [ '*', 80 ],
         body: [
           // Tax
           [ 
               {
                   text:'Rounding Amount($)',
                   style:'itemsFooterTotalTitle',
                   alignment: 'right'

               }, 
               {
                   text: this.poData.amount_total_rounding,
                   style:'itemsFooterTotalValue',
                   alignment: 'right'
               }
           ],
         ]
       }, // table
       layout: 'lightHorizontalLines'
     },
     {
       table: {
         headerRows: 0,
         widths: [ '*', 80 ],
         body: [
           // Tax
           [ 
               {
                   text:'Total Amount ($)',
                   style:'itemsFooterTotalTitle',
                   alignment: 'right'
               }, 
               {
                   text: this.poData.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                   style:'itemsFooterTotalValue',
                   alignment: 'right'
               }
           ],
         ]
       }, // table
       layout: 'lightHorizontalLines'
     },
     { 
         text: 'Remarks',
         style:'notesTitle'
     },
     { 
         text: this.poData.remarks,
         style:'notesText'
     }
,
	    // Signature
	    {
	        columns: [
	            {
	                stack: [
                        { 
	                        text: 'Issued By',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '____________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: 'Name  :'+this.poData.author_user_shortname,
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: 'Date  :'+ poDate,
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },
                {
	                stack: [
                        { 
	                        text: '         ',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '                           ',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: '          ' ,
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: ' ',
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },
	            {
	                stack: [
                        { 
	                        text: 'Received By',
	                        style:'signaturePlaceholder'
	                    },

	                    { 
	                        text: '______________________________',
	                        style:'signaturePlaceholder'
	                    },
	                    { 
	                        text: 'Name  :',
	                        style:'signatureName'
	                        
	                    },
	                    { 
	                        text: 'Date  :',
	                        style:'signatureJobTitle'
	                        
	                    }
	                    ],
	               width: 160
	            },                
	        ]
	    },     
 ],
 styles: {
     // Document Header
     documentHeaderLeft: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'left'
     },
     documentHeaderCenter: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'center'
     },
     documentHeaderRight: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'right'
     },
     // Document Footer
     documentFooterLeft: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'left'
     },
     documentFooterCenter: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'center'
     },
     documentFooterRight: {
         fontSize: 9,
         margin: [5,5,5,5],
         alignment:'right'
     },
     // Invoice Title
     invoiceTitle: {
         fontSize: 20,
         bold: true,
         alignment:'left',
         margin:[0,0,0,15]
     },
     // Invoice Details
     invoiceSubTitle: {
         fontSize: 9,
         alignment:'left'
     },
     invoiceSubValue: {
         fontSize: 9,
         alignment:'left'
     },
     // Billing Headers
     invoiceBillingTitle: {
         fontSize: 12,
         bold: true,
         alignment:'left',
         margin:[0,20,0,5],
     },
     // Billing Details
     invoiceBillingDetails: {
         alignment:'left'

     },
     invoiceBillingAddressTitle: {
         margin: [0,7,0,3],
         bold: true
     },
     invoiceBillingAddress: {
         
     },
     // Items Header
     itemsHeader: {
        
        fontSize: 9,
         margin: [0,5,0,5],
         bold: true
     },
     // Item Title
     itemTitle: {
         bold: true,
     },
     itemSubTitle: {
         //italics: true,
         fontSize: 9
     },
     itemText: {
        fontSize: 9,
         margin: [0,5,0,5],
         alignment: 'left',
     },
     itemNumber: {
        fontSize: 9,
         margin: [0,5,0,5],
         alignment: 'right',
     },
     itemTotal: {
        fontSize: 9,
         margin: [0,5,0,5],
         bold: true,
         alignment: 'right',
     },

     // Items Footer (Subtotal, Total, Tax, etc)
     itemsFooterSubTitle: {
         margin: [0,5,0,5],
         bold: true,
         alignment:'right',
     },
     itemsFooterSubValue: {
         margin: [0,5,0,5],
         bold: true,
         alignment:'center',
     },
     itemsFooterTotalTitle: {
         fontSize: 10,
         margin: [0,5,0,5],
         bold: true,
         alignment:'right',
     },
     itemsFooterTotalValue: {
         fontSize: 10,
         margin: [0,5,0,5],
         bold: true,
         alignment:'center',
     },
     signaturePlaceholder: {
         fontSize: 9,
         margin: [0,70,0,0],   
     },
     signatureName: {
        fontSize: 9,
        margin: [0,10,0,0],
        bold: true,
        alignment:'left',
     },
     signatureJobTitle: {
        fontSize: 9,
        margin: [0,20,0,0],
        bold: true,
        alignment:'left',
     },
     notesTitle: {
       fontSize: 9,
       bold: true,  
       margin: [0,50,0,3],
     },
     notesText: {
       fontSize: 9
     },
     center: {
         alignment:'center',
     },
 },
 defaultStyle: {
     columnGap: 20,
     font:this.font
 }
}
    pdfMake.createPdf(dd).open();
},
        manualClosePO()
        {
            this.$refs.manualCloseModal.hide()
            if (this.poData.po_fulfilment_remarks != '' && this.poData.po_fulfilment_remarks != null)
            {
                axios.post(apiPOManualClose, {po_num: this.poData.po_num, remarks:this.poData.po_fulfilment_remarks},authHeader())
                .then (res => {
                    this.po_status = "MANUAL-CLOSED"
                    this.hideBtns =false
                    this.mbTitle = "Manual Close"
                    this.mbMsg = "PO " + this.poData.po_num + " has been Manual Closed."
                    this.$refs.msgBox.show()
                })
                .catch(error => alert(error))
            }
            else
            {
                this.mbTitle = "Manual Close cancelled"
                this.mbMsg = "Reason has to be provided"
                this.$refs.msgBox.show()
            }

        },
        confirmManualClose()
        {
            this.$refs.manualCloseModal.show()

        },
        fetchPO(poNum)
        {
          axios.post(apiPoGet, {po_num:poNum},authHeader())
            .then (res => 
            { 
              var data
              data = res.data.data
             // console.log(data)
              this.poData = data
              this.poData.title = "Purchase Order " + this.poData.po_num
              
              this.countryId = this.poData.country_id
              console.log(this.countryId)
              if(this.countryId != null)
                {
                    
                    if(this.countryId == 'TH')
                    {
                        this.font = 'Garuda'
                    }
                    else if(this.countryId == 'KH')
                    {
                        this.font = 'Hanumanb'
                    }
                    axios.get(apiCountryLookup, {params: {q: this.countryId}})
                        .then(response => 
                        {

                            if (response.data != null)
                            {
                                this.list = response.data.data.list
                                this.item = this.list[0]
                                this.country_name = this.item.country_name
                                this.country_name = this.country_name.toUpperCase()
                            }
                        })
                }
              
              this.po_status = data.po_status
              this.po_fulfilment_status = data.po_fulfilment_status
            })
            .catch(error => alert(error)
          )
        },
        validateValue(obj, index)
        {
            let ctrl = obj.target.name
            let row = this.poData.po_items[index]
            var qty = row.qty
            var unit_price = row.unit_price
            var amount_total = row.amount_total
            if(ctrl == 'qty')
            {

                if(isNaN(qty))
                {
                    this.poData.po_items[index].qty = 0
                }

            }
            else if(ctrl == 'unit_price')
            {
                if(isNaN(unit_price))
                {
                    this.poData.po_items[index].unit_price = 0
                }
            }
            else if(ctrl == 'amount_total')
            {
                if(isNaN(amount_total))
                {
                    this.poData.po_items[index].amount_total = 0
                }
            }
        },
        computeRow(obj, index)
        {
          let ctrl = obj.target.name
          let row = this.poData.po_items[index]

          var qty = row.qty
          var unit_price = row.unit_price
          var amount_total = row.amount_total

          if (ctrl == 'qty')
          {
            if (!isNaN(unit_price) && !isNaN(amount_total))
            {
              unit_price = unit_price * 1
              qty = qty * 1

              amount_total = qty * unit_price

              if (!isNaN(qty))
                this.poData.po_items[index].qty = qty
              
              if (!isNaN(amount_total))
                this.poData.po_items[index].amount_total = amount_total.toFixed(2)
            }
          }
          else if (ctrl == 'unit_price')
          {
            if (!isNaN(qty) && !isNaN(unit_price))
            {
              unit_price = unit_price * 1
              qty = qty * 1

              amount_total = qty * unit_price

              if (!isNaN(unit_price))
                this.poData.po_items[index].unit_price = unit_price.toFixed(2)
          
              if (!isNaN(amount_total))
                this.poData.po_items[index].amount_total = amount_total.toFixed(2)
              
            }
          }
          else if (ctrl == 'amount_total')
          {
                if (!isNaN(qty) && !isNaN(amount_total))
                {
                    amount_total = amount_total * 1
                    qty = qty * 1
                    unit_price = amount_total / qty

                if (!isNaN(unit_price))
                    this.poData.po_items[index].unit_price = unit_price.toFixed(2)
            
                if (!isNaN(qty))
                    this.poData.po_items[index].qty = qty
            
                if (!isNaN(amount_total))
                    this.poData.po_items[index].amount_total = amount_total.toFixed(2)
                }
          }
        },
        setSupplier(obj)
        {
            if(!this.lockEntry)
            {
                if (obj !== null)
                {
                    this.poData.supplier_id  = obj.id
                    this.poData.po_type = obj.supplier_type
                    this.poData.po_category = obj.supplier_category 
                    this.poData.currency_id = obj.currency_id 
                    this.poData.tax_percent = obj.gst_percent
                } 
                else
                {
                    this.poData.supplier_id  = null
                    this.poData.po_type = null
                    this.poData.po_category = null
                    this.poData.currency_id = null
                    this.poData.tax_percent = 0
                }
            }
        }, 
        setWarehouse(obj)
        {
        
            if(!this.lockEntry)
            {
                var id
                var country_id

                if (obj !== null)
                {
                    if (obj.id != this.poData.location_id)
                    {
                        id = obj.id
                        country_id = obj.country_id
                        this.poData.po_items = []
                        this.poData.location_id = id
                        this.countryId = country_id
                        if (this.poData.location_id != '')
                        {
                            axios.get(this.apiProductUrl,{params: {q:'', q2: this.poData.location_id}})
                                .then (res => { 
                                    var list
                                    list = res.data.data.list
                                    this.noItemsFound = (list.length == 0)
                                })
                                .catch(error => alert(error))
                        }
                        
                    }
                } 
                else
                {
                    id = ""
                    this.noItemsFound = true
                }
            }

        },
        addRow ()
        {
            this.visible =true;
            this.poData.po_items.push({product_name:'', product_id:'', uom:'', qty:'',unit_price:'', amount_total:''});
            this.poItemsCount = this.poItemsCount + 1
        },
        removeRow (index) 
        {
            this.poData.po_items.splice(index, 1);
        },
        setProduct(obj, index)
        {
            if(!this.lockEntry)
            {
                var name, sku, uom
                this.prevWhId = this.poData.location_id
                if(obj !== null)
                {
                    name = obj.name
                    sku = obj.id
                    uom = obj.uom
                }
                else
                {
                    name = ""
                    sku = ""
                    uom = ""
                }

                this.poData.po_items[index].product_name = name
                this.poData.po_items[index].product_id = sku
                this.poData.po_items[index].uom = uom 
            }

        },
        confirmProcessPO()
        {
            if(!this.lockEntry)
            {
                this.confirmMessage = "Saved"
            }
            else
            {
                this.confirmMessage = "Approved"
            }
            this.modalShow = true
        },
        confirmCancel()
        {
        
            this.confirmMessage ="Cancel"
            this.cancelModalShow = true
        },
        back()
        {
            this.$router.push({ name: 'Purchase Orders (POS)'})
        },
        hideModal () 
        {
            this.$refs.myModalRef.hide()
            if(this.$route.params.poNum == '_new')
            {
                //this.$router.push({ name: 'Purchase Order (PO)', params: { poNum: '_new' }})
                //location.reload()
                this.$router.push({ name: 'Purchase Orders (POS)'})
            }
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        hideCancelModal()
        {
            this.$refs.myCancelModalRef.hide()
            this.po_status = "CANCELLED"
        },
        hideApproveModal()
        {
            this.$refs.myApproveModalRef.hide()
            this.po_status = "APPROVED"
        },
       
        validateItems()
        {
            var isValid
            var item

            isValid = true
            
            if (this.poData.po_items.length > 0)
            {
                for(var n=0; n < this.poData.po_items.length; n++)
                {
                    item = this.poData.po_items[n]
                    if (item.product_id == '' 
                        || isNaN(item.qty) || item.qty == ''
                        || isNaN(item.unit_price) || item.unit_price == '' 
                        || isNaN(item.amount_total) || item.amount_total == ''
                        )
                    {
                        isValid = false
                        break
                    }
                    else if (parseInt(item.qty) == 0)
                    {
                        isValid = false
                        break
                    }
                }
            }
            else
                isValid = false

            return isValid
        },
        processPO()
        {           
            if (!this.lockEntry)
            {
                if(1)
                {
                    axios.post(apiPOSave, this.poData, authHeader())
                    .then (res => { 
                    var r = res.data
                    
                    if (r.code == 1)
                    {
                        let docName = r.data.po_num 
                        this.poDocumentNo = docName
                        this.$refs.myModalRef.show()
                    }
                    else
                    {
                        this.errorMessage = r.msg
                        this.$refs.myErrorModalRef.show()
                    }
                    })
                    .catch(error => alert(error))

                }
            }
            else
            {
                // Approve PO
                if(this.po_status == "PENDING")
                {
                    axios.post(apiPOApprove, {po_num: this.poData.po_num, approve: 1},authHeader())
                    .then (res => { 
                        this.hideBtns =false
                        this.$refs.myApproveModalRef.show()
                        this.fetchPO(this.poRef)
                    })
                    .catch(error => alert(error))
                }
            }
        },
        cancel()
        {
            if (!this.lockEntry)
            {
                // Go back to PO Search page
                this.$router.push({ name: 'Purchase Orders (POS)'})
                location.reload()
            }
            else
            {
                // Cancel PO
                axios.post(apiPOApprove, {po_num: this.poData.po_num, approve: 0},authHeader())
                .then (res => { 
                    this.$refs.myCancelModalRef.show()
                })
                .catch(error => alert(error))
            }

        }
      }
    }
    
 </script>
 <style>
  .main {overflow-x: overlay;overflow-y: overlay;}
 </style>



// WEBPACK FOOTER //
// src/views/po/po.vue